export default "__VITE_ASSET__BMoPOJqX__"